import React, {useCallback, useEffect} from 'react';
import {
  Grid,
  List,
  ListItem,
  Typography,
  ListItemText,
  ListItemIcon,
  Table,
  TableBody, TableRow, TableCell, TableHead, Checkbox
} from "@material-ui/core";
import {useAssets} from "../../../hooks/useAssets";
import {useNotify} from "../../../hooks/system/useNotify";
// @ts-ignore
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import {GridDivider} from "../../../components/grids/commons";

export const AssetsPage = () => {
  const {assets, assetClasses, loadClasses, loadAssets} = useAssets(),
    {addNotify} = useNotify()

  useEffect(() => {
    loadClasses().catch(e => {
      addNotify('error', e.message)
    })
  }, [addNotify, loadClasses])

  const onSelectClass = useCallback((id: number) => () => {
    loadAssets(id).catch(e => {
      addNotify('error', e.message)
    })
  }, [addNotify, loadAssets])

  return (
    <>
      <Typography variant="h4">Assets</Typography>
      <Grid container spacing={5}>
        <GridDivider item sm={12} md={4}>
          <List>
            {assetClasses?.map(as => as.id ? (
              <ListItem key={as.id} button onClick={onSelectClass(as.id)}>
                <ListItemText primary={as.description} secondary={'id: '+as.id}  />
                <ListItemIcon>
                  <ChevronRightIcon />
                </ListItemIcon>
              </ListItem>
            ): (<></>))}
          </List>
        </GridDivider>
        <Grid item sm={12} md={8}>
          {assets && (
            <Table size='small'>
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell>name</TableCell>
                  <TableCell>description</TableCell>
                  <TableCell>ticker</TableCell>
                  <TableCell>expired</TableCell>
                  <TableCell>currency</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {assets?.map(a => (
                  <TableRow key={a.id}>
                    <TableCell>{a.id}</TableCell>
                    <TableCell>{a.displayName}</TableCell>
                    <TableCell>{a.description}</TableCell>
                    <TableCell>{a.ticker}</TableCell>
                    <TableCell>
                      <Checkbox checked={a.expired} disabled size="small"/>
                    </TableCell>
                    <TableCell>
                      <Checkbox checked={a.isCurrency} disabled size="small"/>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>

            </Table>
          )}
        </Grid>
      </Grid>
    </>
  );
};
